import http from '../http';

/**
 * Get invitation list
 * @param {Function} callBack - Callback function after successful retrieval
 */
export const getInviteList = async (callBack) => {
  await http.get(`/newapi/tax/user/invite/list`).then(({ data: res }) => {
    callBack && callBack(res);
  });
};

/**
 * Verify promotion code
 * @param {Object} param - Verification parameters object
 * @param {Function} callBack - Callback function after verification
 */
export const verificationCode = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/userCoupon/verification`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Query account information by promotion code
 * @param {Object} param - Parameter object containing code
 * @param {Function} callBack - Callback function after query completion
 */
export const queryAccountByCouponCode = async (param = {}, callBack) => {
  await http.get(`/newapi/tax/account/queryAccountByCouponCode/${param.code}`).then(({ data: res }) => {
    callBack && callBack(res);
  });
};

/**
 * Query coupon information by promotion code
 * @param {Object} param - Parameter object containing code
 * @param {Function} callBack - Callback function after query completion
 */
export const queryCouponByCouponCode = async (param = {}, callBack) => {
  await http.get(`/newapi/tax/userCoupon/queryCouponByCouponCode/${param.code}`).then(({ data: res }) => {
    callBack && callBack(res);
  });
};

/**
 * Query coupon list
 * @param {Object} param - Query parameters object
 * @param {Function} callBack - Callback function after query completion
 */
export const queryCouponList = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/userCoupon/queryCouponList`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};